(async () => {
    if (!customElements.get("tech-slides")) {
        class TechSlides extends HTMLElement {
            constructor() {
                super();
                this.initialise();
                if (typeof Swiper == "undefined") {
                    return false
                }
                this.swiperElement = this.querySelector("[data-tech-slide-swiper]");
                this.swiperOptions = {
                    loop: false,
                    autoplay: false,
                    slidesPerView: 4.5,
                    observer: false,
                    threshold: 10,
                    breakpoints: {
                        320: {
                            slidesPerView: 1.4,
                            spaceBetween: 15
                        },
                        768: {
                            slidesPerView: 2.5,
                            spaceBetween: 20
                        },
                        1024: {
                            slidesPerView: 2.5,
                            spaceBetween: 20
                        },
                        1440: {
                            slidesPerView: 3.5,
                            spaceBetween: 20
                        }
                    }
                };
                if (this && this.dataset && this.dataset.options) {
                    const jsonOptions = JSON.parse(this.dataset.options);
                    if (jsonOptions) {
                        this.swiperOptions = {
                            ...this.swiperOptions,
                            ...jsonOptions
                        }
                    }
                }
                if (Shopify.designMode && this.swiperInstance) {
                    window.addEventListener("shopify:section:load", (() => {
                        this.swiperInstance.update()
                    }))
                }
                this.init()
            }
            init() {
                this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions)
            }
            initialise() {
                var trigger = document.querySelectorAll(".triggerMobile");
                trigger.forEach((ele => {
                    ele.addEventListener("click", (function(e) {
                        var modal = e.currentTarget.closest(".tile").querySelector(".modal");
                        modal.classList.toggle("show-modal");
                        modal.querySelector(".close-button-sm").addEventListener("click", (function(e) {
                            modal.classList.remove("show-modal")
                        }))
                    }))
                }));
                var dTrigger = document.querySelectorAll(".desktop-trigger");
                dTrigger.forEach((deskEle => {
                    deskEle.addEventListener("click", (function(e) {
                        e.preventDefault();
                        var modalId = e.currentTarget.closest(".tile").dataset.blockId;
                        document.getElementById(modalId).classList.add("show-modal");
                        document.getElementById(modalId).querySelector(".close-button").addEventListener("click", (function(e) {
                            document.getElementById(modalId).classList.remove("show-modal")
                        }))
                    }))
                }))
            }
        }
        window.TechSlides = TechSlides;
        customElements.define("tech-slides", TechSlides)
    }
})();
//# sourceMappingURL=tech-slides.js.map